module.exports = __webpack_public_path__ + "static/img/1040_small.2c734f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1040_small.png
// module id = CmwY
// module chunks = 1